import {
  getCountFromServer,
  orderBy,
  Query,
  query,
  where,
} from 'firebase/firestore'
import {
  articlesRef,
  booksRef,
  categoriesRef,
  glossariesRef,
  glossaryDraftsRef,
  textbookDraftsRef,
  textbooksRef,
} from '../firebase'
import { App } from '../types'

export const sortedCategoriesRef = query(categoriesRef, orderBy(`order`))

export const menuActiveCategoriesRef = (app: App) =>
  query(categoriesRef, where(`menu.${app}`, '==', true))

// カテゴリを使っているコンテンツの件数
export type CategoryUsage = {
  textbooks: number
  textbookDrafts: number
  glossaries: number
  glossaryDrafts: number
  articles: number // 公開中のもののみ
  books: number // 公開中のもののみ
}

const countDocs = async (ref: Query<unknown>) =>
  (await getCountFromServer(ref)).data().count

export const getCategoryUsage = async (
  categoryId: string
): Promise<CategoryUsage> => {
  const byCategory = where('category_id', '==', categoryId)
  // 記事と本はFirestoreのルールで公開中のものしか一覧を取得できない
  const isPublic = where('visibility', '==', 'public')
  const [
    textbooks,
    textbookDrafts,
    glossaries,
    glossaryDrafts,
    articles,
    books,
  ] = await Promise.all([
    countDocs(query(textbooksRef, byCategory)),
    countDocs(query(textbookDraftsRef, byCategory)),
    countDocs(query(glossariesRef, byCategory)),
    countDocs(query(glossaryDraftsRef, byCategory)),
    countDocs(query(articlesRef, byCategory, isPublic)),
    countDocs(query(booksRef, byCategory, isPublic)),
  ])
  return {
    textbooks,
    textbookDrafts,
    glossaries,
    glossaryDrafts,
    articles,
    books,
  }
}
